// REACT
import React from "react";

// MATERIAL-UI
import { Grid, Button, Select, MenuItem } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";

// ASSESTS
import { PaginationStyles } from "./styles/Pagination.styles";
import ArrowLeft from "src/icons/ArrowLeftIcon";
import ArrowRight from "src/icons/ArrowRight";

interface PaginationMobileProps {
  count: number;
  page: number;
  current: number;
  onChange: (event: any, newPage: number) => void;
}

const PaginationMobile = (props: PaginationMobileProps) => {
  const classes = PaginationStyles();

  const filterPages = () => {
    const arrayOfPages = Array.from(Array(props.count).keys());
    return arrayOfPages;
  };

  const handleChange = (event: SelectChangeEvent) => {
    const newRows = event.target.value;
    props.onChange(event, +newRows);
  };

  return (
    <Grid container style={{ width: "fit-content" }}>
      {props.count > 0 && (
        <>
          <Grid
            item
            xs
            container
            justifyContent="center"
            alignItems="center"
            className={classes.controls}>
            <Button
              disableRipple
              disabled={props.current === 1}
              classes={{ disabled: classes.disabledButton }}
              onClick={(e) => props.onChange(e, props.current - 1)}>
              <ArrowLeft />
            </Button>
          </Grid>
          <Grid item xs container justifyContent="center" alignItems="center">
            <Select
              variant="standard"
              disableUnderline
              MenuProps={{ classes: { paper: classes.menuPaper } }}
              value={props.current.toString()}
              onChange={handleChange}
              className={classes.select}>
              {filterPages().map((el) => {
                const pages = el + 1;

                return (
                  <MenuItem key={el} value={pages.toString()} translate="no">
                    {pages}
                  </MenuItem>
                );
              })}
            </Select>
          </Grid>
          <Grid
            item
            xs
            container
            justifyContent="center"
            alignItems="center"
            className={classes.controls}>
            <Button
              disableRipple
              disabled={props.current === props.count}
              classes={{ disabled: classes.disabledButton }}
              onClick={(e) => props.onChange(e, props.current + 1)}>
              <ArrowRight />
            </Button>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default PaginationMobile;
